<div class="container-input-checkbox d-flex col-md-10">
  <div class="form-check-change" *ngFor="let checkbox of checkboxs">
    <input class="" type="checkbox" [(ngModel)]="checkbox.isCheck" (click)="emitEventCheckbox(checkbox)">
    <label>
      {{checkbox.name}}
    </label>
  </div>
</div>
